import { IComponentOptions } from 'angular';

export const InstructionsStepComponent: IComponentOptions = {
  template: require('./instructions-step.html'),
  bindings: {
    nextStep: '&',
    prevStep: '&',
  },
  controller() {
    // empty block?
  },
};

angular.module('nv.SupportsModule').component('instructionsStep', InstructionsStepComponent);
